type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;
type LoggerLike = Pick<Console, "log" | "warn" | "error">;

export const TEMPLATE_MARKETPLACE_BOOTSTRAP_SQL = [
  `CREATE TABLE IF NOT EXISTS template_listings (
    id SERIAL PRIMARY KEY,
    slug TEXT NOT NULL UNIQUE,
    owner_user_id TEXT NOT NULL,
    source_app_id INTEGER,
    public_preview_app_id INTEGER,
    current_release_id INTEGER,
    title TEXT NOT NULL,
    summary TEXT NOT NULL DEFAULT '',
    description TEXT NOT NULL DEFAULT '',
    category TEXT,
    tags_json TEXT NOT NULL DEFAULT '[]',
    status TEXT NOT NULL DEFAULT 'draft',
    visibility_intent TEXT NOT NULL DEFAULT 'private',
    price_type TEXT NOT NULL DEFAULT 'free',
    price_cents INTEGER NOT NULL DEFAULT 0,
    currency TEXT NOT NULL DEFAULT 'USD',
    license TEXT,
    rejection_reason TEXT,
    submitted_at TIMESTAMP,
    approved_at TIMESTAMP,
    approved_by TEXT,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE TABLE IF NOT EXISTS template_releases (
    id SERIAL PRIMARY KEY,
    template_id INTEGER NOT NULL,
    version TEXT NOT NULL,
    bundle_hash TEXT NOT NULL,
    bundle_storage_key TEXT NOT NULL,
    source_manifest_json TEXT NOT NULL DEFAULT '{}',
    preview_app_id INTEGER,
    preview_frontend_url TEXT,
    project_kind TEXT NOT NULL DEFAULT 'full_stack',
    frontend_framework TEXT NOT NULL DEFAULT 'unknown',
    package_manager TEXT NOT NULL DEFAULT 'unknown',
    frontend_root TEXT,
    backend_root TEXT,
    build_workdir TEXT,
    build_command TEXT,
    static_output_dir TEXT,
    code_size_bytes BIGINT NOT NULL DEFAULT 0,
    status TEXT NOT NULL DEFAULT 'draft',
    install_status TEXT NOT NULL DEFAULT 'pending',
    install_error TEXT,
    screenshot_status TEXT NOT NULL DEFAULT 'pending',
    screenshot_error TEXT,
    preview_screenshots_json TEXT NOT NULL DEFAULT '[]',
    audit_status TEXT NOT NULL DEFAULT 'pending',
    audit_summary_json TEXT NOT NULL DEFAULT '{}',
    created_by TEXT NOT NULL,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    UNIQUE (template_id, version)
  )`,
  `ALTER TABLE template_releases
    ADD COLUMN IF NOT EXISTS screenshot_status TEXT NOT NULL DEFAULT 'pending',
    ADD COLUMN IF NOT EXISTS screenshot_error TEXT,
    ADD COLUMN IF NOT EXISTS preview_screenshots_json TEXT NOT NULL DEFAULT '[]'`,
  `CREATE TABLE IF NOT EXISTS template_entitlements (
    id SERIAL PRIMARY KEY,
    template_id INTEGER NOT NULL,
    user_id TEXT NOT NULL,
    source TEXT NOT NULL,
    purchase_id INTEGER,
    scope TEXT NOT NULL DEFAULT 'approved_releases',
    granted_at TIMESTAMP DEFAULT NOW() NOT NULL,
    revoked_at TIMESTAMP,
    UNIQUE (template_id, user_id)
  )`,
  `CREATE TABLE IF NOT EXISTS template_purchases (
    id SERIAL PRIMARY KEY,
    template_id INTEGER NOT NULL,
    buyer_user_id TEXT NOT NULL,
    seller_user_id TEXT NOT NULL,
    amount_cents INTEGER NOT NULL,
    currency TEXT NOT NULL,
    provider TEXT NOT NULL DEFAULT 'stripe',
    provider_session_id TEXT,
    provider_payment_id TEXT,
    provider_event_id TEXT,
    status TEXT NOT NULL DEFAULT 'pending',
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    paid_at TIMESTAMP,
    refunded_at TIMESTAMP
  )`,
  `CREATE TABLE IF NOT EXISTS template_events (
    id SERIAL PRIMARY KEY,
    template_id INTEGER NOT NULL,
    release_id INTEGER,
    user_id TEXT,
    event_type TEXT NOT NULL,
    request_fingerprint TEXT,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE TABLE IF NOT EXISTS template_daily_metrics (
    template_id INTEGER NOT NULL,
    day TEXT NOT NULL,
    views INTEGER NOT NULL DEFAULT 0,
    unique_viewers INTEGER NOT NULL DEFAULT 0,
    preview_opens INTEGER NOT NULL DEFAULT 0,
    downloads INTEGER NOT NULL DEFAULT 0,
    cli_clones INTEGER NOT NULL DEFAULT 0,
    purchases INTEGER NOT NULL DEFAULT 0,
    gross_revenue_cents BIGINT NOT NULL DEFAULT 0,
    refunds INTEGER NOT NULL DEFAULT 0,
    UNIQUE (template_id, day)
  )`,
  `CREATE INDEX IF NOT EXISTS idx_template_listings_owner_status
    ON template_listings (owner_user_id, status)`,
  `CREATE INDEX IF NOT EXISTS idx_template_releases_template_status
    ON template_releases (template_id, status)`,
  `CREATE INDEX IF NOT EXISTS idx_template_entitlements_user_template
    ON template_entitlements (user_id, template_id)`,
  `CREATE INDEX IF NOT EXISTS idx_template_purchases_buyer_status
    ON template_purchases (buyer_user_id, status)`,
  `CREATE INDEX IF NOT EXISTS idx_template_events_template_created
    ON template_events (template_id, created_at)`,
];

export async function ensureTemplateMarketplacePlatformSchema(params: {
  rawSql: RawSql;
  isPlatform: boolean;
  logger?: LoggerLike;
}): Promise<void> {
  if (!params.isPlatform) return;
  for (const statement of TEMPLATE_MARKETPLACE_BOOTSTRAP_SQL) {
    await params.rawSql(statement);
  }
  (params.logger ?? console).log("[db] template marketplace tables ✓");
}
